import type { Border, Department, MapGrid, Notch } from '@Model/MapModelsView';

export function convertInto2DArray(departments: Department[]): MapGrid {
  const grid: MapGrid = [];

  for (const department of departments) {
    for (let i = 0; i < department.blockCoordinates.length; i += 2) {
      const x = department.blockCoordinates[i];
      const y = department.blockCoordinates[i + 1];

      // Initialize the column if it doesn't exist yet
      if (!grid[x]) {
        grid[x] = [];
      }

      // Set the department ID at the correct position in the grid
      grid[x][y] = department.departmentId;
    }
  }

  return grid;
}

export function calculateCellBorders(grid: MapGrid): Border[][][] {
  const borderGrid: Border[][][] = [];

  for (let x = 0; x < grid.length; x++) {
    borderGrid[x] = [];

    for (let y = 0; y < (grid[x] ? grid[x].length : 0); y++) {
      borderGrid[x][y] = [];

      // Check if departmentId is undefined. If so, no borders are added.
      if (grid[x][y] === undefined) {
        continue;
      }

      const leftCell = grid[x - 1]?.[y];
      const rightCell = grid[x + 1]?.[y];
      const topCell = grid[x][y - 1];
      const bottomCell = grid[x][y + 1];

      if (leftCell !== grid[x][y]) {
        borderGrid[x][y].push('left');
      }

      if (rightCell !== grid[x][y]) {
        borderGrid[x][y].push('right');
      }

      if (topCell !== grid[x][y]) {
        borderGrid[x][y].push('top');
      }

      if (bottomCell !== grid[x][y]) {
        borderGrid[x][y].push('bottom');
      }
    }
  }

  return borderGrid;
}

export function getNotchForCell(grid: Border[][][]): Notch[][][] {
  const result: Notch[][][] = [];

  grid.forEach((column, x) => {
    result[x] = []; // create column
    column.forEach((cell, y) => {
      result[x][y] = []; // create cell

      if (
        grid[x - 1]?.[y]?.includes('top') &&
        grid[x][y - 1]?.includes('left') &&
        !grid[x][y].includes('left') &&
        !grid[x][y].includes('top')
      ) {
        result[x][y].push('tl');
      }

      if (
        grid[x + 1]?.[y]?.includes('top') &&
        grid[x][y - 1]?.includes('right') &&
        !grid[x][y].includes('right') &&
        !grid[x][y].includes('top')
      ) {
        result[x][y].push('tr');
      }

      if (
        grid[x - 1]?.[y]?.includes('bottom') &&
        grid[x][y + 1]?.includes('left') &&
        !grid[x][y].includes('left') &&
        !grid[x][y].includes('bottom')
      ) {
        result[x][y].push('bl');
      }
      if (
        grid[x + 1]?.[y]?.includes('bottom') &&
        grid[x][y + 1]?.includes('right') &&
        !grid[x][y].includes('right') &&
        !grid[x][y].includes('bottom')
      ) {
        result[x][y].push('br');
      }
    });
  });

  return result;
}
